import React from 'react';

export interface TortaIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const TortaIcon: React.FC<TortaIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 31 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g filter="url(#a)"><path stroke="currentColor" strokeWidth="1.5" d="M8.954 18.777h12.532m3.034-.018h-2.486v-4.81a1.1 1.1 0 0 0-.34-.786 1.2 1.2 0 0 0-.823-.326H9.456c-.309 0-.604.117-.822.325s-.34.49-.34.785v4.81h-2.4c-.303 0-.594.115-.809.32a1.07 1.07 0 0 0-.335.773v6.05c0 .29.12.568.335.773s.506.32.81.32H24.52c.303 0 .594-.115.808-.32s.336-.483.336-.772v-6.05c0-.29-.12-.567-.335-.772a1.17 1.17 0 0 0-.81-.32ZM14.273 9.425h1.346v3.408l-1.346.002zm.98-1.093c.275-.065.52-.216.694-.428.175-.213.27-.475.271-.745 0-.962-.982-2.238-1.025-2.292a.32.32 0 0 0-.246-.117h-.004a.32.32 0 0 0-.246.124c-.104.142-1.021 1.408-1.021 2.287.001.27.097.532.272.745s.419.363.693.428c0 0 .16.044.303.044s.31-.046.31-.046Z"/></g><defs><filter id="a" width="32" height="32.083" x="-.792" y="-.34" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse"><feFlood floodOpacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"/><feBlend in2="BackgroundImageFix" mode="overlay" result="effect1_dropShadow_89_140859"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation=".5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="effect1_dropShadow_89_140859" mode="multiply" result="effect2_dropShadow_89_140859"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_89_140859" result="shape"/></filter></defs>
    </svg>
  );
};

export default TortaIcon;
